export function noop () {
    // placeholder function for default function params
}
